import type { DmPrinter, Print } from '@nsftx/systems-sdk'

const getDetectedPrinters = async (print: Print) => (await print.index()).printers

const getPrinterStatus = (print: Print, { id, queueName }: DmPrinter) =>
  print.getStatus(queueName, id)

const addPrintJob = (print: Print, { id, model }: DmPrinter, template: string) =>
  print.addPrintJob(template, model, id)

const getSupportedPrinters = async (print: Print) => (await print.getPrinters()).Printers

export { getDetectedPrinters, getPrinterStatus, addPrintJob, getSupportedPrinters }
